import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { isTablet } from 'react-device-detect'

export const CardModalButton = styled.div`
  display: block;
  background-color: hsla(0, 0%, 100%, 1);
  padding: 2px 4px;
  border-radius: 100px;
  position: absolute;
  right: ${theme.space[3]};
  top: ${theme.space[2]};
  z-index: 1;

  ${theme.mediaQueries.medium} {
    display: ${isTablet ? 'block' : 'none'};
    right: ${theme.space[6]};
  }

  ${theme.mediaQueries.ipad_landscape} {
    display: block;
  }
`

export const ProductCardWrapper = styled.article`
  position: relative;
  width: 100%;
  ${theme.mediaQueries.medium} {
    &:hover {
      cursor: pointer;
    }
    &:hover ${CardModalButton} {
      display: block;
      position: absolute;
      right: ${theme.space[2]};
      top: ${theme.space[2]};
      z-index: 1;
    }
  }
`

export const ProductCardImage = styled(GatsbyImage)`
  width: 100%;
  height: 125%;
`

export const ProductCardInfoWrapper = styled.div`
  padding: ${theme.space[5]} 0;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  white-space: normal;
`
